/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import serviceCall from '../../../src/store/serviceCall';
import Cookies from 'universal-cookie';
import { maxAge, responseOkCode } from '../../../src/constant';

const cookies = new Cookies();
export const LoginAction = (url, data) => dispatch => {
  dispatch(hasPendingLogin(true));
  serviceCall
    .loginUser(url, data)
    .then(response => {
      if (response.status === responseOkCode) {
        cookies.set('token', `${response.data.customers[0].token}`, {
          path: '/',
          maxAge,
        });
        dispatch(FetchLogin(response.data));
      } else {
        dispatch(errormsg(response));
      }
      dispatch(hasPendingLogin(false));
    })
    .catch(error => {
      dispatch(errormsg(error));
      dispatch(hasPendingLogin(false));
    });
};
export const clearLoginUser = () => ({ type: 'CLEAR_LOGIN_USER_SUCCESS' });
export const forgotpasswordAction = (url, data) => dispatch =>
  serviceCall.forgotemail(url, data).then(res => {
    dispatch(forgetemail(res.status === responseOkCode));
  });

export const updatePasswordAction = (url, data) => dispatch =>
  serviceCall
    .updatePassword(url, data)
    .then(res => {
      if (res) {
        dispatch(resetmsg(res.status));
      }
    })
    .catch(err => {
      dispatch(reseterrormsg(err));
    });

export const resetPasswordAction = (url, data) => dispatch =>
  serviceCall
    .resetPassword(url, data)
    .then(res => {
      if (res) {
        dispatch(resetmsg(res.status));
      }
    })
    .catch(err => {
      dispatch(reseterrormsg(err));
    });

export const userslistAction = url => dispatch =>
  serviceCall.getData(url).then(res => {
    if (res) {
      dispatch(userslist(res.data));
    }
  });
export const usersRemainingCount = url => dispatch =>
  serviceCall.getData(url).then(res => {
    dispatch(remainingCount(res.data));
  });
export const usersAddAction = (url, data) => dispatch =>
  serviceCall.postData(url, data).then(res => {
    dispatch(adduser(res.status));
  });

export const usersDeleteAction = (url, data) => dispatch =>
  serviceCall.deleteData(url, data).then(() => {
    dispatch(deleteusers('1'));
  });

export const sidebaraction = (url, data) => dispatch =>
  serviceCall.getData(url, data).then(res => {
    dispatch(sidebardata(res.data));
  });

export const usereditaction = (url, data) => dispatch =>
  serviceCall.putData(url, data).then(res => {
    dispatch(usereditdata(res.status));
  });

export function hasPendingLogin(data) {
  return { type: 'haspendinglogin', value: data };
}

export function FetchLogin(data) {
  return { type: 'logincall', value: data };
}

export function errormsg(message) {
  return { type: 'errormsg', value: message };
}

export function forgetemail(value) {
  return { type: 'forgetemailsuccessmessage', value };
}
export function storeUrl(data) {
  return { type: 'LINK_STORING_SUCCESS', value: data };
}
export function resetmsg(data) {
  return { type: 'resetmsg', value: data };
}
export function resetState() {
  return { type: 'RESET_REDUX_STATE' };
}

export function reseterrormsg(err) {
  return { type: 'reseterrormsg', value: err };
}

export function userslist(data) {
  return { type: 'userslist', value: data };
}
export function remainingCount(data) {
  return { type: 'GET_REMAINING_COUNT', value: data };
}
export function deleteusers(data) {
  return { type: 'deleteusers', value: data };
}
export function clearDeleteusers() {
  return { type: 'CLEAR_DELETE_USERS' };
}
export function clearAddedUsers() {
  return { type: 'CLEAR_ADDED_USERS' };
}
export function clearEditedUsers() {
  return { type: 'CLEAR_EDITED_USERS' };
}
export const addnewgroup = (url, data) => dispatch =>
  serviceCall
    .postData(url, data)
    .then(res => {
      dispatch(addnewgroupresult(res.status));
    })
    .catch(err => {
      dispatch(errornewgroup(err));
    });
export function addnewgroupresult(data) {
  return { type: 'NewGroupSuccess', value: data };
}
export function getGroupData(url) {
  return dispatch =>
    serviceCall
      .getData(url)
      .then(res => {
        dispatch(getGroupFetch(res.data));
      })
      .catch(err => {
        dispatch(errornewgroup(err));
      });
}

export function getSelectedGroupData(url) {
  return dispatch =>
    serviceCall
      .getData(url)
      .then(res => {
        dispatch(getSelectedGroup(res.data));
      })
      .catch(err => {
        dispatch(errornewgroup(err));
      });
}

export function getLicenseCountAction(url) {
  return dispatch =>
    serviceCall.getData(url).then(res => {
      dispatch(getLicenseCount(res.data));
    });
}
export function getGroupFetch(data) {
  return { type: 'GET_GROUP_VALUE', value: data };
}
export function getSelectedGroup(data) {
  return { type: 'GET_SELECTED_GROUP_VALUE', value: data };
}
export function getLicenseCount(data) {
  return { type: 'GET_LICENSE_COUNT', value: data };
}
export function cleargroupValue() {
  return { type: 'CLEAR_GROUP_VALUE' };
}
export function errornewgroup(data) {
  return { type: 'errornewgroup', value: data };
}
export function validemail(data) {
  return { type: 'validemail', value: data };
}

export function adduser(data) {
  return { type: 'adduser', value: data };
}

export function sidebardata(data) {
  return { type: 'sidebardata', value: data };
}

export function usereditdata(data) {
  return { type: 'usereditdata', value: data };
}
